import keyMirror from '../../util/keyMirror';

export default keyMirror('Services', [
    'LOAD_SERVICES_START',
    'LOAD_SERVICES_SUCCESS',
    'LOAD_SERVICES_FAIL'
]);
